import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { AlertStateModel, AlertDefinition, GetAlerts, NetworkMember, RemoveAlert, Provider, Compass} from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { ConfirmationDialog } from '../../components/confirmation-dialog/confirmation-dialog.component';
import { EditAlertDialog } from '../../components/edit-alert-dialog/edit-alert-dialog.component';



const moment = moment_;

@Component({
  selector: 'alert-definitions',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertDefinitionsComponent implements OnInit {

  @Input() provider : Provider;
  @Input() compass : Compass;
  @Select(state => state.alertState) alertState$: Observable<AlertStateModel>;
  alertSubscription : Subscription;
  alerts : AlertDefinition[];

  constructor(
    private store : Store,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.  alertSubscription  = this.alertState$.subscribe((alertState: AlertStateModel) => {
      console.log(alertState);
      if (alertState && alertState.alerts) {
         this.alerts = [];
         for (let alert of alertState.alerts) {
          let compasses = alert.compasses.filter(c => c.compassControlId === this.compass.versionControlId);
          if (compasses.length > 0) {
            this.alerts.push(alert);
          }
         }
         console.log(this.alerts, this.alerts.map(g => g.name));   
      }
     
    });
    console.log(this.provider);
    this.store.dispatch(new GetAlerts(this.provider.id));

  }

  getCompassesString(alert : AlertDefinition) : string {
    return alert.compasses.map(c => c.compassName).join(',');
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  

  onEdit(data : any) {
    console.log(data);
    if (data === null) {
      //add
      data = {
        id: -1,
        provider : this.provider,
        icon: '',
        text: '',
        sourceCompass : this.compass,
        practitionerGroups : []
      }
    } else {
      data = {
        id : data.id,
        name : data.name,
        icon: data.icon,
        text: data.text,
        sourceCompass : this.compass,
        compasses : data.compasses,
        provider : this.provider,
        practitionerGroups : data.practitionerGroups
      }
    }
    this.dialog.open(EditAlertDialog, {
      width: '600px',
      height: '600px',
      data: data
    });
  }

  onDelete(alert : AlertDefinition) {
    this.dialog.open(ConfirmationDialog, {
      width: '636px',
      data: {
        minWidth: '127px',
        title: 'Delete ' + alert.name,
        body: 'Are you sure you want to delete ' + alert.name + '?',
        buttons: [
          {
            text: 'Cancel',
            class: 'secondary',
            handler: (): boolean => {
              return false;
            }
          },
          {
            text: 'Confirm',
            class: '',
            handler: () => {
              this.store.dispatch(new RemoveAlert(alert.id)).subscribe(r => {
                this.store.dispatch(new GetAlerts(this.provider.id));
              });
            }
          }
        ]
      }
    });
  }
}